import { ArrowRight, Scale, Shield, FileCheck } from "lucide-react";
import { Button } from "./ui/button";

const Hero = ({ content, onOpenChat }) => {
  // Default content if not loaded yet
  const heroContent = content || {
    badge: "Perito Informatico Colegiado CPIICM",
    title_part1: "Evidencias digitales para",
    title_highlight: " procesos judiciales:",
    title_part2: "Análisis forense - Periciales",
    subtitle: "Analisis forense digital con metodologia certificada.",
    cta_primary: "Solicitar Presupuesto",
    cta_secondary: "Ver Servicios",
    stats: [
      { icon: "scale", value: "", label: "casos peritados" },
      { icon: "file", value: "", label: "informes judiciales" }
    ]
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center pt-20 overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background layers */}
      <div className="absolute inset-0 grid-pattern" />
      <div className="absolute inset-0 gradient-radial" />

      {/* Background image with low opacity */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: "url('/fondo.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          mixBlendMode: "screen"
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left content */}
          <div className="animate-fade-in-up">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass border border-sky-400/30 mb-8">
              <Shield className="w-4 h-4 text-sky-400" />
              <span className="text-sm text-slate-300">{heroContent.badge}</span>
            </div>

            {/* Main headline */}
            <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              {heroContent.title_part1}{" "}
              <span className="text-sky-400 text-glow">{heroContent.title_highlight}</span>{" "}
              {heroContent.title_part2}
            </h1>

            {/* Subheadline */}
            <p className="text-lg text-slate-400 leading-relaxed mb-8 max-w-xl">
              {heroContent.subtitle}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <a href="#contacto">
                <Button
                  className="btn-primary text-base w-full sm:w-auto"
                  data-testid="hero-quote-btn"
                >
                  {heroContent.cta_primary}
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </a>
              <a href="#servicios">
                <Button
                  variant="outline"
                  className="btn-secondary text-base w-full sm:w-auto"
                  data-testid="hero-services-btn"
                >
                  {heroContent.cta_secondary}
                </Button>
              </a>
            </div>

            {/* Trust indicators */}
            <div className="flex flex-wrap gap-6 text-sm text-slate-500">
              {heroContent.stats?.map((stat, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  {stat.icon === "scale" ? (
                    <Scale className="w-4 h-4 text-sky-400" />
                  ) : (
                    <FileCheck className="w-4 h-4 text-sky-400" />
                  )}
                  <span>{stat.value} {stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right content — Logo decoration */}
          <div className="hidden lg:flex items-center justify-center animate-fade-in-up animation-delay-200">
            <div className="relative">
              <div className="absolute inset-0 blur-3xl bg-sky-500/20 rounded-full scale-75" />
              <img
                src="/logo.png"
                alt="Perito Informatico Forense"
                className="relative w-80 h-auto opacity-90"
                data-testid="hero-logo"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-slate-900 to-transparent" />
    </section>
  );
};

export default Hero;
